<div class="trip-overview-box">
    <div class="trip-overview-box__container">
        <div class="trip-overview-box__top">
            <p class="trip-name">{{ data.trip.name }}</p>
            <p class="trip-routes">{{ data.extraTripInfo.allRoutes }}</p>
            <p class="trip-duration">{{ data.duration }}</p>
            <div class="trip-actions">
                <button class="btn-default btn-orange" (click)="onEditTrip()">Edit trip</button>
                <button class="btn-default btn-menu" [matMenuTriggerFor]="menu">
                    <mat-icon [svgIcon]="eSvgIcons.MENU_DOTS_HOR"></mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="actionEmitter.emit('Share')">
                        <img class="menu-img" src="assets/svg/ic-export.svg" alt="export">
                        <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="actionEmitter.emit('Print')">
                        <img class="menu-img" src="assets/svg/ic-print-w.svg" alt="print">
                        <span>Print</span>
                    </button>
                    <button mat-menu-item (click)="actionEmitter.emit('Delete')">
                        <img class="menu-img" src="assets/svg/ic-delete.svg" alt="delete">
                        <span>Delete</span>
                    </button>
                </mat-menu>
            </div>
        </div>
        <div class="trip-overview-box__content">
            <div class="trip-map">
                <app-preview-map
                        [savedTripView]="true"
                        [showMapControls]="false"
                        [destinationsRoute]="data.destinationsRoute"
                        (tripLegs)="setParsedTripLegs($event)"
                ></app-preview-map>
            </div>
            @if (data.tripDestinations; as destinations) {
                <ul class="trip-destinations">
                    @for (destination of destinations; track idx; let idx = $index; let last = $last) {
                        <li class="trip-destinations__item">
                            <div class="trip-card">
                                <div class="trip-card__top"
                                     [style.background-image]="'url(' + destination.imageUrl + ')'"
                                ></div>
                                <div class="trip-card__content">
                                    <div class="main-info">
                                        <p class="city-name">{{ destination.cityName }}</p>
                                        @if (destination.dates && destination.dates.start > 1000000000) {
                                            <p class="dates-text">
                                                {{ destination.dates.from + ' - ' + destination.dates.to }}
                                            </p>
                                        }
                                    </div>
                                    <div class="nights-box">
                                        <b>{{ destination.days }}</b> nights
                                    </div>
                                </div>
                                <div class="trip-card__bottom">
                                    <button>
                                        @if ((destination.favorites | getFavoritesByProvider: 'booking.com').length; as hotels) {
                                            <span class="badge">{{ hotels }}</span>
                                        }
                                        Hotels
                                    </button>
                                    <span class="vl-separator"></span>
                                    <button>
                                        @if ((destination.favorites | getFavoritesByProvider: 'viator').length; as viator) {
                                            <span class="badge">{{ viator }}</span>
                                        }
                                        Activities
                                    </button>
                                    <span class="vl-separator"></span>
                                    <button>
                                        @if ((destination.favorites | getFavoritesByProvider: 'occasion_genius').length; as events) {
                                            <span class="badge">{{ events }}</span>
                                        }
                                        Events
                                    </button>
                                </div>
                            </div>
                            @if (!last && legs.length && legs[idx]; as leg) {
                                <div class="leg-box">
                                    <div class="leg-box__pseudo"><span></span></div>
                                    <span class="leg-box__duration">
                                        {{ leg.dist + ' | ' + leg.time }}
                                    </span>
                                </div>
                            }
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
</div>
